var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldCallSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 19.42c-.17.36-.39.7-.68 1.02-.49.54-1.03.93-1.64 1.18-.6.25-1.26.38-1.96.38-1.02 0-2.11-.24-3.26-.73a17.63 17.63 0 0 1-3.45-1.98c-.58-.43-1.15-.87-1.7-1.35l3.26-3.26c.01 0 .01 0 .02.01.52.44.95.74 1.29.92.05.02.11.05.18.08.08.03.16.04.25.04.17 0 .3-.06.41-.17l.76-.75c.25-.25.49-.44.72-.56.23-.14.46-.21.71-.21.19 0 .39.04.61.13.22.09.45.22.7.39l3.32 2.35c.26.18.44.39.55.64.1.25.16.5.16.78 0 .36-.08.73-.25 1.09zM7.5 16.5c-.01 0-.01 0-.02-.01a29.544 29.544 0 0 1-2.8-3.27c-.81-1.12-1.46-2.25-1.94-3.36-.01-.02-.01-.03-.02-.05C2.24 8.67 2 7.58 2 6.54c0-.68.12-1.33.36-1.93.2-.51.5-.99.91-1.42.07-.08.15-.17.24-.25.16-.16.32-.3.49-.41h.01C4.51 2.17 5.04 2 5.6 2c.28 0 .56.06.81.18.24.11.45.27.62.5.02.02.03.04.05.06L9.4 6.01c.18.25.31.48.4.7.09.21.14.42.14.61 0 .24-.07.48-.21.71-.13.23-.32.47-.56.71l-.76.79c-.11.11-.16.24-.16.4 0 .08.01.15.03.23.03.08.06.14.08.2.18.33.49.76.93 1.28.45.52.93 1.05 1.45 1.58l.02.02L7.5 16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.68 2.229 2.23 20.689c-.3.3-.3.79 0 1.09a.758.758 0 0 0 1.08-.01l18.46-18.46c.31-.3.31-.78 0-1.08-.3-.3-.79-.3-1.09 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCallSlash);
export default __webpack_public_path__ + "static/media/vuesax-bold-call-slash.6c6f568bc8ad1151874a8b4203e371a7.svg";
export { ForwardRef as ReactComponent };